const generateORMActionName = ({ slice, actionName }) => {
    return `ORM__${slice}_${actionName}`;
};

export default generateORMActionName;